import validate from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/node_modules/.pnpm/nuxt@3.10.0_@parcel+watcher_0460c02684e6e9175205b127107916c4/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/node_modules/.pnpm/nuxt@3.10.0_@parcel+watcher_0460c02684e6e9175205b127107916c4/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}